<template>
  <div class="modernization-sub-heading" data-aos="fade-up">
    <h1>{{ subHeading }}</h1>
  </div>
  <div class="modernization-benefit-section">
    <v-row>
      <v-col
        data-aos="fade-up"
        v-for="(item, index) in cardItems"
        :key="index"
        :cols="12"
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
        style=""
      >
        <div class="benefit-image-container">
          <div
            @mouseenter="showHover(item.id)"
            @click="showOverlay(item.id)"
          >
            <img
              :src="require(`@/assets/${item.subFolder}/${item.folder}/${item.imageUrl}`)"
              :alt="item.imageUrl"
            >
            <div class="benefit-image-text">
              {{ item.text }}
            </div>
          </div>
          <div
            class='overlay-text'
            @mouseleave="hideHover(item.id)"
            @click="showOverlay(item.id)"
            :id="`overlay-content-${item.id}`"
          >
            <img
              :src="require(`@/assets/capabilities/application modernization/icons/${item.hoverIcon}`)"
              :alt="item.hoverIcon"
            >
            <div>
              {{ item.hoverText }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import { defineComponent} from 'vue';

  export default defineComponent({
    props: {
      subHeading: String,
      cardItems: Object,
    },
    data() {
      return {
        isOverlay: true
      }
    },
    methods: {
      showOverlay(index: any){
        this.clearOverlay();
        let element = document.getElementById(`overlay-content-${index}`)
        
        if(element){
          if(this.isOverlay){
            console.log(element.classList)
            element.classList.remove('hidden');
            element.classList.add('show');
          }else{
            element.classList.remove('show');
            element.classList.add('hidden');
          }
          this.isOverlay = !this.isOverlay
        }
      },
      showHover(index: any) {
        this.clearOverlay();
        const element = document.getElementById(`overlay-content-${index}`);
        if (element) {
          element.classList.add('show');
          element.classList.remove('hidden');
        }
        this.isOverlay = true;
      },
      hideHover(index: any) {
        this.clearOverlay();
        this.isOverlay = false;
      },
      clearOverlay(){
        for(let i = 0; i <= 15; i++){
          const element = document.getElementById(`overlay-content-${i}`);
          if (element) {
            element.classList.remove('show');
            element.classList.add('hidden');
          }
        }
      }
    }
  });
</script>

<style scoped>
.modernization-sub-heading{
  justify-content: center;
  display: flex;
}
.modernization-sub-heading h1{
  margin-top: 20px;
  margin-bottom: 20px;
  color: #336FE5;
  font-size: 40px;
  text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.3);
}
.modernization-benefit-section{
  padding: 20px;
}
.benefit-image-container{
  position: relative;
  width: 100%;
}
.benefit-image-container .benefit-image-text{
  font-size: 40px;
  line-height: 40px;
  width: 100%;
  font-weight: 600;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  padding: 100px;
  text-align: center;
  text-shadow: 1px 4px 6px rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.benefit-image-container img{
  width: 100%;
  height: 433px;
  border-radius: 14px;
  display: block;
  /* filter: contrast(1); */
}
.benefit-image-container::before {
  border-radius: 14px;
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(33, 77, 121, 0.1);
  pointer-events: none;
}
.overlay-text {
  font-size: 32px;
  line-height: 35px;
  width: 100%;
  font-weight: 500;
  font-family: 'Cabin', sans-serif;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  padding: 100px;
  text-align: center;
  text-shadow: 1px 4px 6px rgba(0, 0, 0, 0.4);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  opacity: 0;
  visibility: hidden;
  background-color: #214D79;
  transition: opacity 0.6s, visibility 0.6s;
}
.overlay-text div {
  font-size: 23px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  line-height: 28px;
  max-height: 7.5em;
}
.overlay-text img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}
.benefit-image-container:hover .overlay-text {
  opacity: 1;
  visibility: visible;
}
.hidden{
  opacity: 0;
  visibility: hidden !important;
}
.show{
  opacity: 1;
  visibility: visible !important;
}
@media (max-width: 1350px) {
  .overlay-text{
    font-size: 30px;
    padding: 40px;
  }
  .benefit-image-container .benefit-image-text{
    font-size: 36px;
  }
  .modernization-sub-heading h1{
    margin-top: 18px;
    margin-bottom: 18px;
    font-size: 38px;
  }
  .benefit-image-container img{
    height: 360px;
  }
}
@media (max-width: 1250px) {
  .benefit-image-container img{
    height: 330px;
  }
}
@media (max-width: 1100px) {
  .overlay-text{
    font-size: 28px;
    padding: 25px;
  }
  .benefit-image-container .benefit-image-text{
    font-size: 34px;
  }
  .modernization-sub-heading h1{
    margin-top: 16px;
    margin-bottom: 16px;
    font-size: 36px;
  }
}
@media (max-width: 960px) {
  .overlay-text{
    font-size: 30px;
    padding: 40px;
  }
  .benefit-image-container .benefit-image-text{
    font-size: 36px;
  }
  .modernization-sub-heading h1{
    margin-top: 14px;
    margin-bottom: 14px;
    font-size: 34px;
  }
  .benefit-image-container img{
    height: 450px;
  }
}
@media (max-width: 800px) {
  .overlay-text{
    font-size: 28px;
    padding: 40px;
  }
  .benefit-image-container .benefit-image-text{
    font-size: 34px;
  }
  .modernization-sub-heading h1{
    margin-top: 12px;
    margin-bottom: 12px;
    font-size: 32px;
  }
  .benefit-image-container img{
    height: 400px;
  }
}
@media (max-width: 650px) {
  .overlay-text{
    font-size: 26px;
    padding: 20px;
  }
  .benefit-image-container .benefit-image-text{
    font-size: 32px;
  }
  .modernization-sub-heading h1{
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 30px;
  }
  .benefit-image-container img{
    height: 300px;
  }
}
</style>